import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

export const curriculumData = {
  curriculum: [
    {
      title: 'Programming Foundations',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/One.png"
          placeholder="blurred"
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '6 Weeks',
      tag: null,
      data: [
        'Get comfortable with <span style="font-weight: bold"> Java and Object Oriented Programming </span>  by building a simple Calculator application',
      ],
      skills: null,
      anchor: 'programming-foundations',
      cardTitle: null,
      cards: [
        {
          image: null,
          data: [
            `<ul style="margin: 0; padding-left: 20px; line-height: 1.2;">
           <li>Practice Java Syntax for Loops and conditionals, Arrays, Classes & Objects, Strings, and Collections</li>
           <li>Solve DSA problems by applying Java constructs</li>
           <li>Get comfortable with VSCode and its features</li>
           <li>Gain a practical understanding of OOPs concepts</li>
           <li>Learn Crio's problem solving methodology and solve commonly asked problems</li>
            </ul>`,
          ],
          skills: [
            'Java Syntax Basics',
            'Loops',
            'Conditionals',
            'Strings',
            'Arrays',
            'Collections',
            'Classes and Objects',
            'Constructors',
            'Access Modifiers',
            'Static',
            'Final',
            'OOP Principles',
            'Problem solving',
          ],
          title: 'Language Fundamentals',
        },

        {
          image: {
            childImageSharp: {
              gatsbyImageData: {
                layout: 'constrained',
                placeholder: {
                  fallback:
                    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAABYlAAAWJQFJUiTwAAAC6ElEQVQ4y3WVS0hUURjH//eOEoEEbVtHC2lVi4LooYEwo7UIE3xMoahjvl8z99wZa0KyB6bO3DuNtUlqE20kwWgVBbULIiEqEBQJo1qIKzOI+4/7vlfHxeGec8/5fud7H0ATgKZUQlMWoSlb0AShKwY0YUA35yWGtWedoS1jyZoMuLBNX8A5qCv0vu7w1oLexd4lyqbFsuj2j21o7gFXQ4VyQWGkkKJkAT24YZ21NTQsWZuxCEtl3dnQA6boig2ZyhCT14mZdAAq7K8r4ypisgI+o70ZMDOXZnShlcWPMVY+67LWUkGEobowAgoRzg3+hmMmpjNsfNVC/jvM+T/VPPCll3L2CuWpYaKg+lBdhKG+33ygNfIqX6+eYW4jSiyrxEqKZfEoI92NRFF1TS4B3JUW9qFILsVj7xLEjyTxU6H0tI04WU001RMP9gDqHjCcFpI3F5TnEsSNRuL0ecqxGuJmD1FMO0AvZUoANWGDzDGjEoUMy8YTlMf7iOwAMdJBOZsgJnoJLaChF1TFBQYSNq8SOZWH5gZ5cKaPUrbL9pc5HmUIbYwVt9opz47YUF31I+2mUbAq9hdH+eRzDfm3kgNLF4i7vZR1R/Npleeet7N2OU6sJikt9FO6N+j60w+sCTMrAffH2PamkeQRTvyqI9ZTjNxpYPlQ3PLZPj3J6NerjHwfJtaSlJb6Wd5xkfLtXhMaMtmAmXdTwqh4O8SjvzuJdUGsJInmOkq1USKfolQUxLcksTZKbAji5TXiVBWlnhbiYcZA3jfZsKtCMfBYEB+SxPtuIllPHD9LNF22zcopxIsU8WmQmG8nLsWIE1WE0knMpkNAxwdmUIQh51PEYCsRrSPiDcTkiF0ZeWufmBwimhuIWB0x0EoUAgGxSs9rDk5jMB1r5pl5galZqMwUe21G3ZwX0zuag9gKty/dMd/vIjsbwc4u4863nfliuMGGc2onpNS6ZIMNPwF2ThqhbrzXE6DvfgL+AxeqJsiziNC8AAAAAElFTkSuQmCC',
                },
                backgroundColor: 'transparent',
                images: {
                  fallback: {
                    src: '/static/d55c8df9a40f9b3fe9147dc1b15cb291/9c1f1/Six.png',
                    srcSet:
                      '/static/d55c8df9a40f9b3fe9147dc1b15cb291/9c1f1/Six.png 300w,\n/static/d55c8df9a40f9b3fe9147dc1b15cb291/f159a/Six.png 600w',
                    sizes: '(min-width: 300px) 300px, 100vw',
                  },
                  sources: [
                    {
                      srcSet:
                        '/static/d55c8df9a40f9b3fe9147dc1b15cb291/5de9a/Six.webp 300w,\n/static/d55c8df9a40f9b3fe9147dc1b15cb291/f0b89/Six.webp 600w',
                      type: 'image/webp',
                      sizes: '(min-width: 300px) 300px, 100vw',
                    },
                  ],
                },
                width: 300,
                height: 300,
              },
            },
          },
          data: null,
          skills: null,
          title: null,
        },
      ],
    },
    {
      title: 'Data Structures and Algorithms',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Two.png"
          placeholder="blurred"
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '10 weeks',
      tag: null,
      data: [
        'Get introduced to <span style="font-weight: bold">DSA</span> with problems related to <span style="font-weight: bold">arrays and strings.</span>',
      ],
      skills: [],
      anchor: 'dsa',
      cardTitle: null,
      cards: [
        {
          image: null,
          data: [
            `<ul style="margin: 0; padding-left: 20px; line-height: 1.2;">
             <li>Develop logic building skills by solving simple math, recursion, and implementation problems</li>
              <li>Understand Time & Space complexity</li>
             <li>Get introduced to data structures & traversals – LinkedList & Trees</li>
            </ul>`,
          ],
          skills: [
            'Logic Building',
            'Recursion',
            'Collections',
            'Introduction to Data Structures',
            'Space and Time Complexity',
          ],
          title: '',
        },
        {
          image: null,
          data: [
            `Learn various patterns of problem solving involving arrays & strings.
            <ul style="margin: 0; padding-left: 20px; line-height: 1.2;">
              <li>Get introduced to problem patterns that involve arrays</li>
              <li>Learn how to recognize these patterns in problems</li>
              <li>Solve the most frequently asked problems across these patterns</li>
             </ul>`,
          ],
          skills: [
            'Matrix',
            'Two Pointers',
            'Sliding Window',
            'Prefix Sum',
            'Bit Manipulation',
            'Sorting',
            'Binary Search',
          ],
          title: 'Array Patterns and Problems',
        },
        {
          image: null,
          data: [
            `Learn about new data structures and how to implement and apply them to solve DSA problems.
    <ul style="margin: 0; padding-left: 20px; line-height: 1.2;">
      <li>Solve DSA problems involving Hash, Queue, and Stack</li>
      <li>Learn and solve Linked List related patterns and problems</li>
      <li>Leverage BFS/DFS effectively to solve multiple tree problems</li>
    </ul>`,
          ],
          skills: [
            'Stack',
            'Queue',
            'Hash',
            'Linked List',
            'Binary Tree',
            'Binary Search Tree',
            'BFS',
            'DFS',
          ],
          title: 'Stack/Queue, Linked List, Tree',
        },

        {
          image: {
            childImageSharp: {
              gatsbyImageData: {
                layout: 'constrained',
                placeholder: {
                  fallback:
                    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAABYlAAAWJQFJUiTwAAAC6ElEQVQ4y3WVS0hUURjH//eOEoEEbVtHC2lVi4LooYEwo7UIE3xMoahjvl8z99wZa0KyB6bO3DuNtUlqE20kwWgVBbULIiEqEBQJo1qIKzOI+4/7vlfHxeGec8/5fud7H0ATgKZUQlMWoSlb0AShKwY0YUA35yWGtWedoS1jyZoMuLBNX8A5qCv0vu7w1oLexd4lyqbFsuj2j21o7gFXQ4VyQWGkkKJkAT24YZ21NTQsWZuxCEtl3dnQA6boig2ZyhCT14mZdAAq7K8r4ypisgI+o70ZMDOXZnShlcWPMVY+67LWUkGEobowAgoRzg3+hmMmpjNsfNVC/jvM+T/VPPCll3L2CuWpYaKg+lBdhKG+33ygNfIqX6+eYW4jSiyrxEqKZfEoI92NRFF1TS4B3JUW9qFILsVj7xLEjyTxU6H0tI04WU001RMP9gDqHjCcFpI3F5TnEsSNRuL0ecqxGuJmD1FMO0AvZUoANWGDzDGjEoUMy8YTlMf7iOwAMdJBOZsgJnoJLaChF1TFBQYSNq8SOZWH5gZ5cKaPUrbL9pc5HmUIbYwVt9opz47YUF31I+2mUbAq9hdH+eRzDfm3kgNLF4i7vZR1R/Npleeet7N2OU6sJikt9FO6N+j60w+sCTMrAffH2PamkeQRTvyqI9ZTjNxpYPlQ3PLZPj3J6NerjHwfJtaSlJb6Wd5xkfLtXhMaMtmAmXdTwqh4O8SjvzuJdUGsJInmOkq1USKfolQUxLcksTZKbAji5TXiVBWlnhbiYcZA3jfZsKtCMfBYEB+SxPtuIllPHD9LNF22zcopxIsU8WmQmG8nLsWIE1WE0knMpkNAxwdmUIQh51PEYCsRrSPiDcTkiF0ZeWufmBwimhuIWB0x0EoUAgGxSs9rDk5jMB1r5pl5galZqMwUe21G3ZwX0zuag9gKty/dMd/vIjsbwc4u4863nfliuMGGc2onpNS6ZIMNPwF2ThqhbrzXE6DvfgL+AxeqJsiziNC8AAAAAElFTkSuQmCC',
                },
                backgroundColor: 'transparent',
                images: {
                  fallback: {
                    src: '/static/d55c8df9a40f9b3fe9147dc1b15cb291/9c1f1/Six.png',
                    srcSet:
                      '/static/d55c8df9a40f9b3fe9147dc1b15cb291/9c1f1/Six.png 300w,\n/static/d55c8df9a40f9b3fe9147dc1b15cb291/f159a/Six.png 600w',
                    sizes: '(min-width: 300px) 300px, 100vw',
                  },
                  sources: [
                    {
                      srcSet:
                        '/static/d55c8df9a40f9b3fe9147dc1b15cb291/5de9a/Six.webp 300w,\n/static/d55c8df9a40f9b3fe9147dc1b15cb291/f0b89/Six.webp 600w',
                      type: 'image/webp',
                      sizes: '(min-width: 300px) 300px, 100vw',
                    },
                  ],
                },
                width: 300,
                height: 300,
              },
            },
          },
          data: null,
          skills: null,
          title: null,
        },
      ],
    },
    {
      title: 'SQL',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Three.png"
          placeholder="blurred"
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '1 week',
      tag: null,
      data: [
        'Learn about the essentials of <span style="font-weight: bold">SQL</span> by working with logical operators, aggregate functions, and joins.',
      ],
      skills: [],
      anchor: 'tech-stack',
      cardTitle: null,

      cards: [
        {
          image: null,
          data: [
            `<ul style="margin: 0; padding-left: 20px; line-height: 1.2;">
     <li>Enhance your <span style="font-weight: bold">SQL</span> knowledge by learning about aggregates and joins, and practice writing queries</li>
    </ul>`,
          ],
          skills: ['SQL Logical Operators', 'Aggregate Functions', 'SQL Joins'],
          title: '',
        },

        {
          image: {
            childImageSharp: {
              gatsbyImageData: {
                layout: 'constrained',
                placeholder: {
                  fallback:
                    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAABYlAAAWJQFJUiTwAAAC6ElEQVQ4y3WVS0hUURjH//eOEoEEbVtHC2lVi4LooYEwo7UIE3xMoahjvl8z99wZa0KyB6bO3DuNtUlqE20kwWgVBbULIiEqEBQJo1qIKzOI+4/7vlfHxeGec8/5fud7H0ATgKZUQlMWoSlb0AShKwY0YUA35yWGtWedoS1jyZoMuLBNX8A5qCv0vu7w1oLexd4lyqbFsuj2j21o7gFXQ4VyQWGkkKJkAT24YZ21NTQsWZuxCEtl3dnQA6boig2ZyhCT14mZdAAq7K8r4ypisgI+o70ZMDOXZnShlcWPMVY+67LWUkGEobowAgoRzg3+hmMmpjNsfNVC/jvM+T/VPPCll3L2CuWpYaKg+lBdhKG+33ygNfIqX6+eYW4jSiyrxEqKZfEoI92NRFF1TS4B3JUW9qFILsVj7xLEjyTxU6H0tI04WU001RMP9gDqHjCcFpI3F5TnEsSNRuL0ecqxGuJmD1FMO0AvZUoANWGDzDGjEoUMy8YTlMf7iOwAMdJBOZsgJnoJLaChF1TFBQYSNq8SOZWH5gZ5cKaPUrbL9pc5HmUIbYwVt9opz47YUF31I+2mUbAq9hdH+eRzDfm3kgNLF4i7vZR1R/Npleeet7N2OU6sJikt9FO6N+j60w+sCTMrAffH2PamkeQRTvyqI9ZTjNxpYPlQ3PLZPj3J6NerjHwfJtaSlJb6Wd5xkfLtXhMaMtmAmXdTwqh4O8SjvzuJdUGsJInmOkq1USKfolQUxLcksTZKbAji5TXiVBWlnhbiYcZA3jfZsKtCMfBYEB+SxPtuIllPHD9LNF22zcopxIsU8WmQmG8nLsWIE1WE0knMpkNAxwdmUIQh51PEYCsRrSPiDcTkiF0ZeWufmBwimhuIWB0x0EoUAgGxSs9rDk5jMB1r5pl5galZqMwUe21G3ZwX0zuag9gKty/dMd/vIjsbwc4u4863nfliuMGGc2onpNS6ZIMNPwF2ThqhbrzXE6DvfgL+AxeqJsiziNC8AAAAAElFTkSuQmCC',
                },
                backgroundColor: 'transparent',
                images: {
                  fallback: {
                    src: '/static/d55c8df9a40f9b3fe9147dc1b15cb291/9c1f1/Six.png',
                    srcSet:
                      '/static/d55c8df9a40f9b3fe9147dc1b15cb291/9c1f1/Six.png 300w,\n/static/d55c8df9a40f9b3fe9147dc1b15cb291/f159a/Six.png 600w',
                    sizes: '(min-width: 300px) 300px, 100vw',
                  },
                  sources: [
                    {
                      srcSet:
                        '/static/d55c8df9a40f9b3fe9147dc1b15cb291/5de9a/Six.webp 300w,\n/static/d55c8df9a40f9b3fe9147dc1b15cb291/f0b89/Six.webp 600w',
                      type: 'image/webp',
                      sizes: '(min-width: 300px) 300px, 100vw',
                    },
                  ],
                },
                width: 300,
                height: 300,
              },
            },
          },
          data: null,
          skills: null,
          title: null,
        },
      ],
    },
    {
      title: 'Web Development',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/One.png"
          placeholder="blurred"
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '6 weeks',
      tag: null,
      data: [
        'Build a responsive static front-end landing page for <span style="font-weight: bold">XCruise</span>, a cruise booking company, and learn <span style="font-weight: bold">HTML, CSS</span>, and <span style="font-weight: bold">responsive design</span>.',
      ],
      skills: null,
      anchor: 'software-development-with-ai',
      cardTitle: null,
      cards: [
        {
          image: null,
          data: [
            `<ul style="margin: 0; padding-left: 20px; line-height: 1.2;">
              <li>Master HTML elements, tags, and attributes by using them to structure the web pages of XCruise</li>
              <li>Learn CSS and its layout options like Grid and Flexbox by utilizing them to enhance the layout and position of various elements on the web page</li>
              <li>Learn Bootstrap by using it to design a responsive web page</li>
            </ul>`,
          ],
          skills: [
            'HTML',
            'CSS',
            'Flexbox',
            'CSS Grid',
            'Bootstrap',
            'Responsive Design',
            'Git',
          ],
          title: '',
        },
        {
          image: null,
          data: [
            `
            <ul style="margin: 0; padding-left: 20px; line-height: 1.2;">
              <li>Learn JavaScript and add life to the web pages by making them dynamic</li>
              <li>Start learning JS Syntax, Loops and conditionals, Arrays, Objects, Strings, and ES6 features</li>
              <li>Utilize your DOM manipulation skills to access and update web page content</li>
            </ul>`,
          ],
          skills: [
            'Data Types',
            'Keywords',
            'Operators',
            'Conditionals',
            'Loops',
            'Arrays',
            '2D Arrays',
            'Strings',
            'Functions',
            'DOM Manipulation',
            'Closure',
            'Promises',
            'Async-await',
          ],
          title: 'Language Foundations - JS',
        },
      ],
    },

    {
      title: 'Interview Blitz',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Five.png"
          placeholder="blurred"
          width={300}
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '2 weeks',
      tag: null,
      data: [
        'Refine your learnings from previous Sprints and practice answering conceptual interview questions, DSA questions, etc.',
      ],
      skills: [],
      anchor: 'system-design',
      cardTitle: null,

      cards: [
        {
          data: [
            `<ul style="padding-left: 20px; line-height: 1.2;">
              <li>Perfect the art of cracking the developer roles related DSA interviews through multiple DSA sessions</li>
              <li>Practice the most commonly asked interview questions to ace your interview</li>
              <li>Practice multiple timed mock DSA assessments</li>
              <li>Get confident for your upcoming interviews by giving a mock interview</li>
            </ul>`,
          ],
          skills: [
            'Technical Questions',
            'Behavioral Questions',
            'Online Assessments',
            'DSA Mocks',
            'Mock Interviews',
            'Aptitude',
          ],
          title: '',
        },
      ],
    },
    {
      title: 'LLM Fundamentals for NextGen Developers',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Six.png"
          placeholder="blurred"
          width={300}
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '1 week',
      tag: null,
      data: [
        `Gain end-to-end <span style="font-weight: bold">LLM practice, and prompt engineering</span> for advanced solutions like RAG`,
      ],
      skills: [],
      anchor: 'interview',
      cardTitle: null,
      cards: [
        {
          image: null,
          data: [
            `
          <ul style="margin: 0; padding-left: 20px; line-height: 1.2;">
            <li><strong>Develop</strong> foundational knowledge of LLMs, their use cases, ecosystem, providers, model types, and prompt engineering.</li>
            <li><strong>10x</strong> your productivity as a developer using Bolt, Cursor, and other GenAI tools to speed up prototyping, code reviews, and documentation.</li>
          </ul>`,
          ],
          skills: [
            'LLM',
            'Prompt Engineering',
            "OpenAI API's",
            'RAG',
            'Bolt',
            'Cursor',
          ],
          title: '',
        },
      ],
    },
    {
      title: 'Full Stack Projects',
      staticImage: (
        <StaticImage
          imgStyle={{ objectFit: 'contain' }}
          loading="lazy"
          src="../images/v5/CurriculumIcons/Seven.png"
          placeholder="blurred"
          width={300}
          alt="Mobile Navbar"
        />
      ),
      image: null,
      duration: '24 weeks',
      chip: 'career step up',
      tag: null,
      data: [],
      options: [
        { tag: 'frontend-specialization', title: 'Frontend Specialization' },
        { tag: 'backend-specialization', title: 'Backend Specialization' },
      ],
      anchor: 'externship',
      cardTitle: null,
      cards: [
        {
          data: [
            `<p>Build a responsive static front end for <strong>QTrip</strong>, an AirBnB-like travel planning website, and utilize your HTML, CSS, Bootstrap skills, and more.</p>
            <ul style="margin: 0; padding-left: 20px; line-height: 1.2;">
              <li>Perform wireframing and use your HTML knowledge to create the structure of the different pages of the QTrip website.</li>
              <li>Utilize your Bootstrap skills to create a responsive Navbar, Hero Section, and Cards for the QTrip website.</li>
              <li>Create engaging layouts by using Bootstrap Flex and Bootstrap Grids.</li>
            </ul>`,
          ],
          title: 'QTripStatic',
          skills: [
            'Bootstrap',
            'CSS Positioning',
            'CSS Inheritance',
            'Deployment',
          ],
          tag: 'frontend-specialization',
        },
        {
          data: [
            `<p>Add life to the web pages of <strong>QTrip</strong> by making them dynamic and by integrating with a backend and 3rd party UI features. Apply your learnings from <strong>QTrip Static</strong> and <strong>QTrip Dynamic</strong> to build your first independent project, XBoard- a newsfeed that aggregates articles from popular media outlets.</p>
      <ul style="margin: 0; padding-left: 20px; line-height: 1.2;">
        <li>Make API calls using JavaScript and use it to make QTrip pages dynamic.</li>
        <li>Utilize your DOM Manipulation skills by actually performing it with data fetched from API calls.</li>
        <li>Integrate 3rd party JS libraries and build engaging new features like image galleries in <span style="font-weight: bold">QTrip</span>.</li>
        <li>Add filters to <span style="font-weight: bold">QTrip</span> and learn to persist user preferences using local storage.</li>
        <li>Utilize RSS feeds to display a newsfeed dynamically on your XBoard websites.</li>
        <li>Enhance XBoard UI using Accordions and Carousels.</li>
      </ul>`,
          ],
          title: 'QTripDynamic, XBoard',
          skills: [
            'Event Handling',
            'Forms',
            'Fetch API',
            'localStorage',
            'Deployment',
          ],
          tag: 'frontend-specialization',
        },
        {
          data: [
            `<p>Build the frontend for the Register and Login page of <strong>QKart</strong> - an online ecommerce store to learn React, and create a rich shopping experience.</p>
            <ul style="margin: 0; padding-left: 20px; line-height: 1.2;">
              <li>Get introduced to objects and classes in JS, including concepts such as constructors, this keyword, super keyword, and Inheritance using the extends keyword.</li>
              <li>Learn about functional programming and write pure functions.</li>
              <li>Get started with React components and props to create a modular single-page frontend application (SPA).</li>
              <li>Dive deep into React component state and lifecycle management.</li>
              <li>Add React events and event binding.</li>
              <li>Create UI using Material UI and create Controlled Components for the Register and Login pages in QKart.</li>
              <li>Implement frontend routing and React routes in QKart.</li>
            </ul>`,
          ],
          title: 'QKart Frontend',
          skills: [
            'Objects and Classes in JS',
            'Functional Programming',
            'Class-based Components',
            'Lifecycle methods',
            'Functional Components',
            'React Hooks',
            'Controlled Components',
            'React Router',
            'Material UI',
            'Deployment',
          ],
          tag: 'frontend-specialization',
        },
        {
          data: [
            `<p>Build the Products page, shopping cart, and the Checkout page for <strong>QKart</strong> - an online ecommerce store to learn React, and create a rich shopping experience. Build the frontend for <strong>QTify</strong> - a Spotify-like music streaming platform.</p>
            <ul style="margin: 0; padding-left: 20px; line-height: 1.2;">
              <li>Optimize API calls by implementing debouncing for the search feature.</li>
              <li>Add the cart functionality in QKart for users to go on a shopping spree!</li>
              <li>Build a checkout page in QKart that allows users to add their shipping details and review the items in their cart before ordering them.</li>
              <li>Make parallel API calls by using Promise Combinators.</li>
              <li>Learn about some advanced React Hooks and create custom Hooks as well.</li>
              <li>Just like an actual frontend take-home, build a project (QTify) when all you’re given is a Figma file and API endpoints.</li>
              <li>Gain skills to plan, approach, and ace a frontend take-home round.</li>
            </ul>`,
          ],
          title: 'QKart Frontend, QTify',
          skills: [
            'Debouncing',
            'Mocking API calls',
            'Promise Combinators',
            'Advanced Hooks',
            'Custom Hooks',
            'Material UI',
            'Module-scoped CSS',
            '3rd-party UI library integration',
          ],
          tag: 'frontend-specialization',
        },
        {
          data: [
            `<p>Start your backend development journey by building <strong>QMoney</strong>, a visual stock portfolio analyser.</p>
          <ul style="margin: 0; padding-left: 20px; line-height: 1.2;">
            <li>Handle JSON-formatted data using Jackson - a standard Java library.</li>
            <li>Get financial data for QMoney by making 3rd party REST API calls using Spring REST Template.</li>
            <li>Implement OOP abstraction using Java Interfaces.</li>
            <li>Refactor your code in Java and bulletproof your implementations using unit tests.</li>
            <li>Use Java build systems like Gradle to create your own JAR files.</li>
            <li>Get exposed to a variety of situations where you learn to perform exception handling and debug like a top backend developer.</li>
            <li>Build a news curator Java Application called XNews by applying all of what you have learnt in the sprint.</li>
          </ul>`,
          ],
          title: 'Core Java',
          skills: [
            'JSON',
            'Gradle',
            'Exception Handling',
            'File Handling',
            'Rest APIs',
            'Okhttp',
            'Jackson',
          ],
          tag: 'backend-specialization',
        },
        {
          data: [
            `<p>Build a scalable Java backend for <strong>QEats</strong>, a Swiggy-like food ordering app, using Spring Boot, while developing multiple mini-applications with the Spring Project.</p>
          <ul style="margin: 0; padding-left: 20px; line-height: 1.2;">
            <li>Learn Spring Basics and build the QEats backend (a Swiggy-like app).</li>
            <li>Develop REST APIs in Spring Boot using MVC architecture.</li>
            <li>Connect QEats to MongoDB using Spring Data.</li>
            <li>Implement logging with Spring Boot and monitor with Actuator.</li>
            <li>Secure APIs with JWT and Spring Security, covering authentication/authorization.</li>
            <li>Explore microservices architecture, document and test APIs with Swagger and Postman.</li>
          </ul>`,
          ],
          title: 'Backend',
          skills: [
            'Spring Basics',
            'Spring Boot',
            'Spring Data JPA',
            'Spring Data MongoDB',
            'Spring Security',
            'JWT Authentication',
            'MVC Architecture',
            'Lombok',
            'Microservices',
            'Postman',
            'Swagger',
          ],
          tag: 'backend-specialization',
        },
      ],
    },
  ],
};
